module.exports = __webpack_public_path__ + "../resources/images/SkyCode_50-2a3170da8ecc9873bfd4609457fd4b1e.svg";